import { render, staticRenderFns } from "./GrButtonPrimary.vue?vue&type=template&id=68c2ae88&"
import script from "./GrButtonPrimary.vue?vue&type=script&lang=ts&"
export * from "./GrButtonPrimary.vue?vue&type=script&lang=ts&"
import style0 from "./GrButtonPrimary.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VHover } from 'vuetify/lib/components/VHover';
installComponents(component, {VBtn,VHover})
